import * as React from 'react'

const Time = (props: { time: string }) => {
  return <div className='trip-time-box font-black p02'>{props.time}</div>
}

export default Time



// WEBPACK FOOTER //
// ./src/components/ui/FormatTimeInTrip.tsx